<div *ngIf="requiredAmount" class="details-row">
  <span translate class="details-label">questionBoard.edit.expense.requiredAmount</span>
  <span class="details-value">{{ requiredAmount | number:'1.0-2' }} ₪</span>
</div>
<div *ngIf="approvedAmount" class="details-row">
  <span translate class="details-label">questionBoard.edit.expense.approvedAmount</span>
  <span class="details-value">{{ approvedAmount | number:'1.0-2' }} ₪</span>
</div>
<div *ngIf="expenseRowsCount" class="details-row">
  <span translate class="details-label">questionBoard.edit.expense.rowsCount</span>
  <span class="details-value">{{ expenseRowsCount }}</span>
</div>
<div *ngIf="comment" class="details-row">
  <span translate class="details-label">questionBoard.edit.expense.rejectionReason</span>
  <span class="details-value ellipsis">{{ comment}}</span>
  <div class="tooltip-abs">
    <p>{{ comment }}</p>
  </div>
</div>